import { IconButton } from '@mui/material';
import CallIcon from '@mui/icons-material/CallTwoTone';
import styles from './ApplicationLink.module.css';

interface PhoneLinkProps {
  phoneNumber: string;
  extension?: string;
  showIcon?: boolean;
  className?: string;
  emptyText?: string;
  title?: string;
}

/**
 * Component for rendering a telephone number link and extension. Returns a formatted phone number (000) 000-0000 with the extension when present.
 */
export default function PhoneLink(props: PhoneLinkProps) {
  if (props.showIcon) {
    return (
      <IconButton
        className={styles['icon-btn']}
        href={`tel:${props.phoneNumber}`}
        disabled={!props.phoneNumber}
        title={props.title ? props.title : (formatPhoneNumber(props.phoneNumber) ?? undefined)}>
        <CallIcon fontSize='inherit' />
      </IconButton>
    );
  } else {
    if (!props.phoneNumber) {
      return <span className={props.className}>{props.emptyText}</span>;
    }

    return (
      <span
        className={props.className}
        title={props.title ? props.title : props.phoneNumber}>
        <a
          href={`tel:${props.phoneNumber}`}
          className={styles.link}>
          {formatPhoneNumber(props.phoneNumber)}
        </a>
        {props.extension && ` ext. ${props.extension}`}
      </span>
    );
  }
}

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return null;
  }

  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};

export const formatPhoneNumberDashes = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return null;
  }

  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }
  return null;
};
